import Module from "module";

import type {
  Helmet as HelmetType,
  HelmetProvider as HelmetProviderType,
} from "react-helmet-async";

import { isPlatformNodeJS } from "@utils/common";

/**
 * NB: We re-export react-helmet-async as the cjs interface isn't properly
 * compatible with ESM.
 */
let Helmet: typeof HelmetType;
let HelmetProvider: typeof HelmetProviderType;

if (isPlatformNodeJS()) {
  const require = Module.createRequire(import.meta.url);
  const module = require("react-helmet-async");

  Helmet = module.Helmet;
  HelmetProvider = module.HelmetProvider;
} else {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  const module = require("react-helmet-async");

  Helmet = module.Helmet;
  HelmetProvider = module.HelmetProvider;
}

export { Helmet, HelmetProvider };
